import mongoose from 'mongoose';
export interface LibraryConfig {
  environment: string;
}

export type DeploymentEnv = 'dev' | 'ci' | 'staging' | 'prod';

const DEPLOYMENT_ENV_ALIASES: Record<string, DeploymentEnv> = {
  development: 'dev',
  dev: 'dev',
  production: 'prod',
  prod: 'prod',
  staging: 'staging',
  ci: 'ci',
};

export const resolveDeploymentEnv = (raw?: string): DeploymentEnv | undefined =>
  raw ? DEPLOYMENT_ENV_ALIASES[raw.trim().toLowerCase()] : undefined;

export const buildEventsQueueName = (env: string) => `events-${env}`;

export const normalizeDeploymentEnv = (raw?: string) =>
  resolveDeploymentEnv(raw) ??
  String(raw ?? '')
    .trim()
    .toLowerCase();

export const buildTranscriptReadyStreamName = (env?: string) =>
  `agora:${normalizeDeploymentEnv(env)}:streams:transcript_ready_queue_stream`;

export const createRedisLibrary = (config: LibraryConfig) => {
  const REDIS_PREFIX = `agora:${config.environment}`;

  const REPORT_PDF_QUEUE_STREAM = `${REDIS_PREFIX}:streams:report_pdf_queue_stream`;
  const REPORT_PDF_STATUS_HASH = `${REDIS_PREFIX}:hashes:report_pdf_status_hash`;

  const COURSE_QUEUE_STREAM = `${REDIS_PREFIX}:streams:course_queue_stream`;
  const COURSE_STATUS_HASH = `${REDIS_PREFIX}:hashes:course_status_hash`;

  const TRANSLATION_QUEUE_STREAM = `${REDIS_PREFIX}:streams:translation_queue_stream`;
  const TRANSLATION_STATUS_HASH = `${REDIS_PREFIX}:hashes:translation_status_hash`;

  const PARTICIPANT_AUDIO_QUEUE_STREAM = `${REDIS_PREFIX}:streams:participant_audio_queue_stream`;
  const PARTICIPANT_AUDIO_STATUS_HASH = `${REDIS_PREFIX}:hashes:participant_audio_status_hash`;

  const TRANSCRIPT_READY_QUEUE_STREAM = buildTranscriptReadyStreamName(config.environment);

  const REDIS_CONSUMER = `${REDIS_PREFIX}:consumer:${new mongoose.Types.ObjectId().toHexString()}`;
  const REDIS_CONSUMER_GROUP = `${REDIS_PREFIX}:consumer_group`;

  return {
    REDIS_PREFIX,
    REPORT_PDF_QUEUE_STREAM,
    REPORT_PDF_STATUS_HASH,
    COURSE_QUEUE_STREAM,
    COURSE_STATUS_HASH,
    TRANSLATION_QUEUE_STREAM,
    TRANSLATION_STATUS_HASH,
    PARTICIPANT_AUDIO_QUEUE_STREAM,
    PARTICIPANT_AUDIO_STATUS_HASH,
    TRANSCRIPT_READY_QUEUE_STREAM,
    REDIS_CONSUMER,
    REDIS_CONSUMER_GROUP,
  };
};
